import { Button, Container, DropdownMenu } from "reactstrap";
import styled from "styled-components";
import {
  DropdownItem as ReactDropdownItem,
  DropdownToggle as ReactDropdownToggle,
  Button as ReactButton,
  Offcanvas as ReactOffCanvas,
  Input,
  CloseButton as ReactCloseButton,
  FormGroup,
} from "reactstrap";
import { isMobileOnly } from "react-device-detect";

// DEPRECATED: use reactstrap button
const ProjectButton = styled(Button)`
  font-size: ${(props) => props.size};
  background-color: var(--bs-primary);
  border: 1px solid var(--bs-primary);
  margin-left: 8px;
  padding: ${(props) => props.padding};
  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    background-color: var(--bs-primary) !important;
    border: 1px solid var(--bs-primary) !important;
  }
  &:disabled {
    background: #dddddd;
    color: #aaaaaa;
    border: 1px solid #dddddd !important;
  }
`;

const ProjectButtonSec = styled(Button)`
  font-size: ${(props) => props.size};
  background-color: transparent;
  border: 1px solid var(--bs-secondary);
  color: var(--bs-secondary);
  margin-left: 8px;
  padding: ${(props) => props.padding};
  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    background-color: var(--bs-secondary) !important;
    color: white;
  }
  &:disabled {
    background: #dddddd;
    color: #aaaaaa;
  }
`;

const FullScreenContainer = styled(Container)`
  height: 95vh;
`;

const ParentContainer = styled.div`
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border: 1px solid black;
  background: #eee;
`;

const ChildContainer = styled.div`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  background: #fff;
`;

const GroupContainer = styled.div`
  border-bottom: 1px solid lightgray;
  &:hover {
    background-color: rgb(220, 220, 220);
  }
  &.active {
    background-color: rgb(240, 240, 240);
  }
`;

const GroupText = styled.p`
  margin: 0;
  color: gray;
`;

const SettingsDropdownMenu = styled(DropdownMenu)`
  transform: translate(0px, 35.75px) !important;
`;

const DisabledFeature = styled.div`
  color: #999;
  cursor: not-allowed;

  &:hover::after {
    content: "Premium Feature";
    position: absolute;
    background-color: white;
    color: grey;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 10px;
    z-index: 1;
  }
`;

const DimensionText = styled.p`
  writing-mode: ${(props) =>
    props.isvertical === "true" ? "vertical-lr" : "horizontal-tb"};
  font-size: 12px !important;
  margin: 5px 0 0 0;
  text-align: center;
`;
const PanelContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  margin: 5px;
`;

const LabelPrintingContainer = styled.div`
  width: 210mm;
  height: 297mm;
  padding: 0;
  color: #000;
  box-sizing: border-box;
`;

const ItemContainer = styled.div`
  width: 66.66mm;
  height: 27mm;
  margin: 1mm;
  float: left;
  position: relative;
  page-break-inside: avoid;
  font-family: sans-serif;
  font-weight: 400;
  font-size: 13px;
  box-sizing: border-box;
  overflow: hidden;
`;

const LastItem = styled.div`
  &.last_item {
    page-break-after: always;
  }
`;

const Label1Logo = styled.div`
  position: absolute;
  top: 2mm;
  right: 2mm;
`;

const Label1 = styled.div`
  position: absolute;
  left: 2mm;
  top: 2mm;
  font-size: 4mm;
  width: 10mm;
  height: 10mm;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 10mm;
`;

const Label2 = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 3mm;
`;

const Label2_1 = styled.div`
  font-size: 8mm;
`;

const Label2_2 = styled.div`
  font-size: 5mm;
  margin-left: 2mm;
`;

const RoomDetails = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 3mm;
  bottom: 7mm;
  padding: 1mm;
`;

const PanelDetails = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  bottom: 1mm;
  font-size: 3mm;
  padding: 1mm;
`;

const OrderItemLabel = styled.div`
  border: 1px solid black;
  font-size: 32px;
  height: 40px;
  width: 40px;
  font-weight: 700;
  border-radius: 50%;
  padding: 0px 7px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AssemblyFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  position: absolute;
  bottom: 12px;
  width: 98%;
`;

const RenderCanvasElement = styled.div`
  position: absolute;
  left: ${(props) => {
    return props.object.position.x / props.renderingsize + "px";
  }};
  bottom: ${(props) => props.object.position.y / props.renderingsize}px;
  height: ${(props) => props.object.dimensions.height / props.renderingsize}px;
  width: ${(props) => props.object.dimensions.width / props.renderingsize}px;
  background: ${(props) => props.object.is_old_mode && "#ddd"};
`;

const RenderSectionCanvasElement = styled.div`
  position: absolute;
  left: ${(props) => {
    return props.object.position.x / props.renderingsize + "px";
  }};
  bottom: ${(props) => props.object.position.y / props.renderingsize}px;
  height: ${(props) => props.object.dimensions.height / props.renderingsize}px;
  width: ${(props) => props.object.dimensions.width / props.renderingsize}px;
  background: ${(props) => props.object.is_old_mode && "#ddd"};
`;

const ToggleContainer = styled.div`
  width: 20px;
  height: 12px;
  background: ${(props) => (props.isOn ? "#2C92E6" : "#999999")};
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
`;

const ToggleCircle = styled.div`
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: ${(props) => (props.isOn ? "calc(100% - 10px)" : "2px")};
  transform: translateY(-50%);
  transition: left 0.3s ease-in-out;
`;

const RenderCanvasElementForAssembly = styled.div`
  position: absolute;
  left: ${(props) =>
    (props.position ? props.position.x : props.object.position.x) /
      props.renderingsize +
    "mm"};
  bottom: ${(props) =>
    (props.position ? props.position.y : props.object.position.y) /
      props.renderingsize +
    "mm"};
  height: ${(props) => props.object.dimensions.height / props.renderingsize}mm;
  width: ${(props) => props.object.dimensions.width / props.renderingsize}mm;
  background: ${(props) => props.object.is_old_mode && "#ddd"};
`;

const ProjectImgContainer = styled.div`
  width: 50px;
  height: 50px;
`;

const ProjectInfoContainer = styled.div`
  background: gainsboro;
`;

const ProjectInfoPill = styled.span`
  padding: 2px 5px;
  border-radius: 6px;
  font-size: 0.9em;
  border: 1px solid #aaa;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const IconContainer = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  width: 1.1em;
  height: 1.1em;
  margin-right: 10px;
`;

const ProjectInput = styled(Input)`
  position: absolute;
  opacity: 0;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const ProjectProductInfo = styled.span`
  color: ${(props) => props.color};
  overflow: hidden;
  -webkit-line-clamp: ${(props) => props.line};
  -webkit-box-orient: vertical;
  display: -webkit-box;
  &.active {
    color: ${(props) => props.activecolor};
  }
`;

const ProjectRoomPrice = styled.p`
  font-size: ${(props) => props.size};
`;

const CloseButton = styled(ReactCloseButton)`
  opacity: 1;
  padding: 8px 10px;
  filter: invert(1) grayscale(100%) brightness(200%);
  &:hover {
    filter: none;
    opacity: 1;
    color: #000;
    background-color: #f8f9fa;
  }
`;

const DropdownItem = styled(ReactDropdownItem)`
  font-size: 14px;
`;

const DropdownToggle = styled(ReactDropdownToggle)`
  background-color: ${(props) => props.bgcolor};
  &:hover {
    background-color: ${(props) => props.hoverBgColor};
  }
`;

const ExpoIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  height: ${(props) => props.height || "25px"};
  width: ${(props) => props.width || "28px"};
  border: 1px dashed #868686;
  &.Top {
    border-top: 3px solid #868686;
  }
  &.Right {
    border-right: 3px solid #868686;
  }
  &.Bottom {
    border-bottom: 3px solid #868686;
  }
  &.Left {
    border-left: 3px solid #868686;
  }
`;

const GroupInfoContainer = styled.div`
  width: 100%;
`;

const ModalButton = styled(ReactButton)`
  padding: 4px 16px;
`;

const Offcanvas = styled(ReactOffCanvas)`
  row-gap: 4px;
`;

const OrderItemContainer = styled.div`
  background-color: ${(props) => props.bgcolor || ""};
`;

const AccordionHeaderContainer = styled.div`
  padding-right: 10px;
  margin-bottom: -1px;

  .accordion-button:not(.collapsed) {
    box-shadow: none !important;
  }

  .accordion-button(.not-collapsed) {
    box-shadow: none !important;
  }
`;

const DimensionSpan = styled.span`
  display: flex;
  align-items: center;

  input {
    width: 30px;
    border: 0px;
    padding: 0px;
    margin-right: 5px;
    background: transparent;
  }

  input:focus {
    border: 1px solid gray;
    padding: 5px;
    background: white;
    width: 60px;
  }

  span {
    margin-right: 5px;
    font-size: 14px;
    font-weight: bold;
  }
`;

const SortButton = styled.button`
  padding: 5.5px 0.75rem;
  border-radius: 0.375rem;
  border: 0;
  background: inherit;
  color: #3b3b5b;

  &.active {
    color: black;
    background: white;
  }
`;

const ProjectSettingsFormGroup = styled(FormGroup)`
  margin: 0 !important;
`;

const SummaryButton = styled.button.attrs({
  className: "rounded-1 border-0",
})`
  background-color: #d9d9d9;
  color: #666666;
  padding: 5px 10px;
  font-size: 1.2em !important;

  &.active {
    background-color: var(--bs-primary);
    color: white;
  }
`;

const ColorPicker = styled.div.attrs({
  className: "position-relative rounded-circle overflow-hidden",
})`
  height: ${(props) => props.height || "70px"};
  width: ${(props) => props.width || "70px"};
  margin-bottom: 6px;
  border: 1px solid #666666;

  &:hover {
    box-shadow: 0px 0px 4px 1px #555555;
  }

  &.disabled:hover {
    box-shadow: none;
  }
`;

const ColorIcon = styled.div.attrs({
  className: "rounded-circle overflow-hidden",
})`
  height: 45px;
  width: 45px;
  margin-bottom: 6px;
  border: 1px solid #666666;
`;

const UploadButton = styled.button.attrs({
  className: "bg-white rounded-2",
})`
  font-size: 10px !important;
  color: #2c92e6;
  padding: 6px 12px;
  border: 1px solid #2c92e6;
`;

const RightArrowPointer = styled.div.attrs({
  className: "",
})`
  width: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid ${(props) => props.color};
`;

const ListSummaryDimensionInput = styled(Input)`
  height: 100%;
  width: 100%;
  background: transparent;
  border: none;
  padding: 4px;
  text-align: center;

  &:focus {
    background: #fff;
  }

  &:disabled {
    background: transparent;
    border: none;
  }
`;

const TableDialogFooter = styled.div.attrs({
  className: "border-top py-0 px-3 mt-3",
})`
  margin-left: -1rem !important;
  margin-right: -1rem !important;
`;

const TableDialogBtn = styled(Button).attrs({
  className: "px-3 py-1",
})`
  background: white !important;
  border: 1px solid ${(props) => props.border || "#aaaaaa"};
  color: ${(props) => props.color || "#666666"} !important;
}}
`;

const TableViewDialog = styled.div.attrs({
  className: `position-absolute top-0 bg-light-grey`,
})`
  border: 1px solid #bbb;
  border-radius: 5px;
  box-shadow: 5px 5px 10px #ccc;
  z-index: 9;
  width: max-content;
  padding: ${(props) => (props.padding ? 0 : "1rem")};
  left: ${(props) => (isMobileOnly || props.end === "true" ? undefined : 0)};
  right: ${(props) => (isMobileOnly || props.end === "true" ? 0 : undefined)};

  &.no-padding {
    padding: 0;
  }
`;

const TableViewToggler = styled(Button).attrs({
  className: "rounded-pill",
})`
  padding-block: 4px 3px !important;
  background: inherit !important;
  color: white;
  border: 1px solid white !important;
  border-radius: 10px;
  font-weight: 600;

  &.active {
    background: #2c92e6 !important;
    border: 1px solid #2c92e6 !important;
  }
`;
const CirclePoint = styled.div`
  width: 4px;
  height: 4px;
  background-color: #999;
  border-radius: 50%;
`;

export {
  AccordionHeaderContainer,
  AssemblyFooter,
  ChildContainer,
  CloseButton,
  DimensionSpan,
  DimensionText,
  DisabledFeature,
  DropdownItem,
  DropdownToggle,
  ExpoIcon,
  FullScreenContainer,
  GroupContainer,
  GroupInfoContainer,
  GroupText,
  IconContainer,
  ItemContainer,
  Label1,
  Label1Logo,
  Label2_1,
  Label2_2,
  Label2,
  LabelPrintingContainer,
  LastItem,
  ModalButton,
  Offcanvas,
  OrderItemContainer,
  OrderItemLabel,
  PanelContainer,
  PanelDetails,
  ParentContainer,
  ProjectButton,
  ProjectButtonSec,
  ProjectImgContainer,
  ProjectInfoContainer,
  ProjectInfoPill,
  ProjectInput,
  ProjectProductInfo,
  ProjectRoomPrice,
  ProjectSettingsFormGroup,
  RenderCanvasElement,
  RenderSectionCanvasElement,
  RenderCanvasElementForAssembly,
  ToggleCircle,
  ToggleContainer,
  RoomDetails,
  SettingsDropdownMenu,
  SortButton,
  SummaryButton,
  ColorPicker,
  ColorIcon,
  UploadButton,
  RightArrowPointer,
  ListSummaryDimensionInput,
  TableDialogFooter,
  TableDialogBtn,
  TableViewDialog,
  TableViewToggler,
  CirclePoint,
};
